import Page from '@/features/Services/pages/CCTV'

export default Page
